<template>
  <div class="people">
    <h2>{{$t('lang.people_title')}}</h2>
    <p>{{$t('lang.people_text')}}</p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.people {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  h2 {
    font-size: 32px;
    font-weight: 400;
    margin-top: 120px;
    margin-bottom: 60px;
    @media screen and (max-width: 768px) {
      font-size: 28px;
      margin-top: 30px;
      margin-bottom: 20px;
    }
  }
  p {
    font-size: 16px;
    line-height: 32px;
  }
}
</style>
